import React, { useEffect, useLayoutEffect, useRef, useCallback, useState } from 'react';
import { Button, CONTAINED_VARIANT, NO_ICON, SIZE_48 } from '@yme/atoms/button';
import { Col, Container, Row } from '@yme/atoms/grid';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { CookieListSkeleton } from './CookieListSkeleton';
import { wrapElement } from './helpers';
import { CookieListStyled } from './styled';
export function CookieList({ isRemoveBottomIndent, isInEditor }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const ref = useRef(null);
    const { t } = useTranslation();
    useEffect(() => {
        // https://my.onetrust.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?topicId=0TO1Q000000ssJBWAY
        function reloadOTBanner() {
            const otConsentSdk = document.getElementById('onetrust-consent-sdk');
            if (otConsentSdk) {
                otConsentSdk.remove();
            }
            if (window.OneTrust != null) {
                window.OneTrust.Init();
                window.OneTrust.LoadBanner();
            }
        }
        reloadOTBanner();
    }, []);
    useLayoutEffect(() => {
        if (!ref.current)
            return;
        const observer = new MutationObserver(() => {
            setIsLoaded(true);
            if (!isInfiniteDesktopView) {
                const tables = ref.current?.getElementsByTagName('table');
                for (const item of tables) {
                    const divWrapper = document.createElement('div');
                    divWrapper.classList.add('table-wrapper');
                    wrapElement(item, divWrapper);
                }
            }
            observer.disconnect();
        });
        observer.observe(ref.current, {
            childList: true,
        });
        return () => {
            observer.disconnect();
        };
    }, [isInfiniteDesktopView]);
    const handleOpenSettings = useCallback(() => {
        window.OneTrust.ToggleInfoDisplay();
    }, []);
    const isShowSkeleton = !isInEditor && !isLoaded;
    return (React.createElement(React.Fragment, null,
        React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Container, null,
                React.createElement(Row, { mt: "16px", mdMt: "24px", lgMt: "48px" },
                    React.createElement(Col, null,
                        React.createElement(CookieListStyled, { id: "ot-sdk-cookie-policy", ref: ref, isShowSkeleton: isShowSkeleton }),
                        isShowSkeleton && React.createElement(CookieListSkeleton, null))),
                !isShowSkeleton && (React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement(FlexWrapper, { justifyContent: "center", mt: "40px", mtTablet: "48px" },
                            React.createElement(Button, { size: SIZE_48, hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, label: t('cookieList_cookiesSettings_button'), width: isMobileView ? '100%' : 'auto', onClick: handleOpenSettings }))))))),
        React.createElement(SpinnerLoader, { isLoading: isShowSkeleton, fullWidth: true })));
}
CookieList.displayName = 'CookieList_AEMComponent';
